import NdrPanel from "../../components/NdrPanel";

export default function Ndr() {
  return <NdrPanel />;
}
